import { GET_GUEST_SEARCH_FAILURE, GET_GUEST_SEARCH_REQUEST, GET_GUEST_SEARCH_SUCCESS } from "../../../Utils/Constant";



  export const guestSearchRequest = (payload) => {
    return {
      type: GET_GUEST_SEARCH_REQUEST,
      payload: payload,
    };
  };
  
  export const guestSearchSuccess = (data) => {
    return {
      type: GET_GUEST_SEARCH_SUCCESS,
      payload: data,
    };
  };
  
  export const guestSearchFailure = (error) => {
    return {
      type: GET_GUEST_SEARCH_FAILURE,
      payload: error,
    };
  };
